module.exports = __webpack_public_path__ + "static/media/rel_propostas_emitidas.4b154749.svg";